<template>
    <div>
        <div   style="margin-top:2px;text-align:center;line-height:30px;background:#409eff;color:white;height:35px">
            <i class="iconfont icon-kaoqinguanli1" style="color:#fff;font-size:14px;margin-right:6px;"></i>
            <el-link :underline="false" @click="btnDay">
                <i class="web-font" style="font-size:12px; font-weight:700;color:#fff">今天</i>
            </el-link>
            <el-link :underline="false" @click="prevMth" style="margin-right:10px;margin-left:20px">
                <i class="iconfont icon-zuoshuangjiantou" style="font-size:12px; font-weight:700;color:#fff"> </i>
            </el-link>
            <el-date-picker :clearable="false" v-model="v_mth" size="mini" style="width:120px;height:15px; margin-top:2px" @change="changeDate" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>           
            <el-link :underline="false" @click="nextMth" style="margin-left:10px">
                <i class="iconfont icon-shuangjiantou" style="font-size:12px; font-weight:700;color:#fff"> </i>
            </el-link>
            <el-link :underline="false" @click.native="dayList" style="margin-left:20px;line-height:30px; ">            
                <i class="iconfont icon-zhanghuguanli-baobiao" style="font-size:12px; font-weight:700;color:#fff;margin-right:4px">日志明细</i>
            </el-link>
        </div>
        <div class="app-container">
            <calendar :height="tabHeight" ref="refcal"  
                        :show-title="false"
                        @date-click="dayClick"
                        :show-festival="false"
                        :show-term="false"
                        :select-date="selDate" 
                        :default-date="defaultDate">
                <template slot="dateCell" slot-scope="{date}">
                    <span slot="reference" class="css_obj">
                        <div v-if="rmkArr.filter(item=>item['DTTM']==`${date.year+'-'+ date.month +'-'+date.day}` ).length>0">
                            <i class="iconfont icon-yuandianxiao" style="color:red"> </i> 
                        </div>
                        <el-button icon="el-icon-edit" size="mini" circle @click="editRec(date)"></el-button>
                    </span>
                </template>
            </calendar>
        </div>
        <!-- 日历事项 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="dayWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 工作日志  </span>
            </div> 
            <div style="display:flex; height:35px;margin-bottom:6px">
                <div style="line-height:30px;height:30px;font-size:12px;width:90px">当前选中日期</div>
                <!-- <el-input size="small" v-model="v_dttm" disabled style="width:120px"></el-input> -->
                <span style="font-weight:600;font-size:12px;line-height:30px;color:#389">{{v_dttm}} {{v_week}}  </span>
                <div style="line-height:30px;height:30px;font-size:12px;width:90px;margin-left:20px; ">当前用户名称</div>
                <span style="font-weight:600;font-size:12px;line-height:30px;color:#389">{{v_usernm}}</span>
            </div>
            <div class="one-toolbar">
                <span class="spanRow"> 基础信息 </span>
            </div>        
            <Form :model="mainRow" :label-width="120"   label-position="right" inline  >  
                <span v-for="(item,index) in mainCol" :key="index" >
                    <FormItem   :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <template slot="label" > {{item.title}}</template>
                        <el-date-picker size="small" :disabled="saveFlag " type="date"  v-if="item.edcss==='date'" v-model="mainRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input size="small" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="mainRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div class="one-toolbar">
                <span class="spanRow"> 工作明细 </span>
                【
                    <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link   @click="dtlAdd" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">新增记录</span></el-link>   
                】
            </div>
            <el-table  :data="dtlData" 
                border                            
                size="small"
                ref="refdtl"
                :header-cell-style="{'height':'20px'}"
                cell-class-name="clearPadding"
                :cell-style="{padding:'2px'}"
                :height="300" 
                class="custom-table-border"
                highlight-current-row >  
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                    <template slot-scope="scope">                   
                        <el-time-select size="mini" v-if="item.key=='FRTIME'||item.key=='TOTIME'" v-model="scope.row[item.key]" :picker-options="{start: '06:30',step: '00:15',end: '23:30'}" placeholder="选择时间" style="width:100%"></el-time-select>
                        <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                        <el-input @focus="inputBtn(scope.row,scope.$index,item.key)" clearable  v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="border:1px solid #389" > </el-input>     
                        <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                    </template> 
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="80">
                    <template slot-scope="scope"> 
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link   @click="dtlDel(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:2px;">删除</span> </el-link>
                    </template>
                </el-table-column>
            </el-table> 
            <div class="one-toolbar">
                <span class="spanRow"> 上传附件</span>
            </div>
            <div style="display:flex" >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :with-credentials="true"
                    :max-size="20480"
                    :on-exceeded-size="handleMaxSize"
                    type="drag"
                    :on-progress="handleProgress"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:150px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;"  >
                    <span v-for="(item,index) in imgData" :key="index">  
                        <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> 删除</el-link>
                            <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                            <el-link v-else :underline="false" style="margin-right:3px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                        </div>
                    </span>
                </div> 
            </div>
      
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;  ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dayWin=false" style="margin-right:50px;">退出</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>         
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:v_cond="t_cond" v-bind:v_random="v_random" v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <!-- 编辑框 -->
        <el-dialog  v-dialogDrag   :visible.sync="editWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑框</span>
            </div> 
            <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="v_rmk"> </el-input>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;  ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="editWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="rmkOk" style="margin-right:10px;">确定</el-button>         
                </span>
            </div>
        </el-dialog> 
        <!-- 工作日历明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="logWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 工作日志明细 </span>
            </div> 
            <div  style="background:white;height:92vh;overflow-y:auto"> 
                <div style="display:flex; position:fixed; ">
                    <div style=" padding-left:1px;margin-top:10px "> 
                        <el-timeline style="width:130px;margin-top:5px;padding-left:8px">
                            <el-timeline-item
                                v-for="(item, index) in timeArr"
                                :key="index"
                                @click.native="handleTime(item,index)"
                                :icon="item.ICON"
                                :type="item.TY"
                                :color="currentIndex==index?'red':'#389'">
                            <span style="font-size:11px"> {{item.DAYDTTM}}</span>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                    <div style=" border-left :2px solid #389;width:100%;height:92vh"  >
                        <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px">
                            <div style="width:55px;padding-left:2px; border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">开始时间</div>
                            <div style="width:55px;padding-left:2px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">结束时间</div>
                            <div style="width:64%;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">工作内容</div>
                            <div style="width:90px;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">关联任务单号</div>
                            <div  style="width:140px;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600; ">任务名称</div>
                            <div  style="width:15%;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600">备注</div>
                        </div>
                        <div style="overflow-y:auto;height:97%; ">
                            <span v-for="(item,index) in timeArr " :key="index" >
                                <div  :ref="item.DAYDTTM">
                                    <div :style="{ width:divWidth}" style="line-height:30px;height:34px;background:#ccc;width:100%;padding-left:6px;margin-bottom:6px">
                                        <span style="font-size:12px;font-weight:700;color:#389;"> 工作日期：{{item.DAYDTTM}}【{{item.WEEK}}】 </span>
                                    </div>
                                    <span v-for="(subitem,subindex) in dayArr.filter(it=>it['IDSEQ']==item['IDSEQ']) " :key="subindex" >
                                        <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px">
                                            <div style="width:55px;padding-left:5px; border-right:1px solid #ccc">{{subitem['FRTIME']}}</div>
                                            <div style="width:55px;padding-left:5px;border-right:1px solid #ccc">{{subitem['TOTIME']}}</div>
                                            <div :title="subitem['TITLE']" style="width:64%;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['TITLE']}}</div>
                                            <div style="width:90px;padding-left:5px;border-right:1px solid #ccc">{{subitem['REFWKNO']}}</div>
                                            <div :title="subitem['JOBDESC']" style="width:140px;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['JOBDESC']}}</div>
                                            <div :title="subitem['RMK']" style="width:15%;padding-left:5px;border-right:1px solid #ccc; white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['RMK']}}</div>
                                        </div>
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import 'vue-lunar-calendar-pro/dist/calendar.css';
import Calendar from 'vue-lunar-calendar-pro'  
import pubWin from '../datamgt/pubwin.vue'  
import { getTabColOrData,getBaseData } from '../../api/user'
import {getDate,getWeek} from '../../api/Select' 
 
import FileSaver from 'file-saver'
    export default {
        name:"employee_log",
        data() {
            return {
                editWin:false,
                v_rmk:'',
                v_index:'',
                timeArr:[],
                currentIndex:'0',
                logWin:false,
                promptWin:false,
                prompt:'',
                uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
                Accept: "png,jpg,jpeg,gif,tiff,pdf,xls,xlsx,doc,docx",
                saveFlag:true,
                rmkArr:[],
                selDate:[],
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url: 'xuper_auth/getTableRecMany',
                defaultDate:'',
                v_mth:'',
                v_dttm:'',
                year:'',
                dayWin:false,
                v_idseq:'',
                mainCol:[],
                dtlCol:[],
                dtlData:[],
                mainRow:{},
                v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
                delDtlArr:[],
                chkIndex: 0,
                uploadData:{}, //上传数据
                videoFlag:false,
                videoUploadPercent:0,
                imgData:[],
                fileName:'',
                delImg:[],
                v_table:'',
                tableCol :[],
                v_key2 :'',
                v_value2 :'',
                btnWin:false,
                v_key:'',
                t_cond:'',
                wkCol:[],
                v_tabIndex:'',
                v_tabrow:{},
                v_random:'',
                dayArr:[],
                v_commit :true,
                v_row:{},
                v_out:'',
                v_week:'',
                v_lang:this.$store.state.lang,
            }
        },
        mounted () {
            getBaseData('xuper_auth/getBaseData','userno',this.v_username,'','','v_sys_user','').then(res=>{
                this.v_out =res.result[0]['ISOUT']
            })
        },
        created () {
            if (this.v_username){ 
                this.year =getDate('yr')
                this.defaultDate=getDate()
                this.selDate =[getDate()]
                this.v_mth =getDate('month')
                this.initCal() //初始化日历数据
                this.getTabField()

            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        components: {
            Calendar,
            pubWin,
        },
        computed:{
            tabHeight: function() {
                return (window.innerHeight - 110) + 'px';
            }, 
            tabWidth: function() {
                return (window.innerWidth - 200) + 'px';
            }, 
            divWidth: function() {
                return (window.innerWidth - 350) + 'px';
            }, 
            selWidth: function() {
                return (window.innerWidth - 220) + 'px';
            },
        },
        methods: {
            downFile(filePath){
                const arr_name=filePath.split("/")
                const file_name=arr_name[arr_name.length-1] //获取文件名
                FileSaver.saveAs(filePath,file_name) 
            },
            handleTime(active,index){
                this.currentIndex=index
                // ref 用在v-for上时，得到的是一个数组，用在普通元素上，直接是 dom名
                this.$nextTick(()=>{
                    this.$refs[active['DAYDTTM']][0].scrollIntoView({behavior:"smooth",block:"start"}) 
 
                })        
            } ,
            btnSure(obj){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{REFWKID:obj['IDSEQ'],REFWKNO:obj['IDNO'],JOBDESC:obj['JOBDESC'] } ))
                this.chkIndex =this.v_tabIndex              
                this.btnWin =false
            },
            rmkOk(){
                this.dtlData.splice(this.v_index,1,Object.assign(this.v_row,{TITLE:this.v_rmk}))
                this.editWin =false
            },
            inputBtn( row, index, key){
                let v_cond=''
                if (key =='TITLE'){
                    this.v_rmk =row['TITLE']
                    this.v_index =index
                    this.v_row =JSON.parse(JSON.stringify(row))
                    this.editWin =true

                }else {
                    this.v_random=Math.random()
                    this.v_table ='v_bs_plan'
                    this.tableCol =this.wkCol
                    this.v_key2 =''
                    this.v_value2=''
                    this.v_tabIndex =index
                    this.v_tabRow =row
                    if (this.v_out =='Y'){
                        v_cond = ' and supno in (select empno from V_sys_user where userno=\''+this.v_username+'\' )'
                    }
                    this.t_cond =v_cond + ' and  stfg not in (\'OK\',\'END\')' 
                    this.btnWin =true
                }
            },
            //预览PDF
            pdfViewer(path){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            },
            //图片删除，操作数组
            imgDel(item,index){
                if(item['IDSEQ'] && item['LSTSEQ']){
                    
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'refidseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG'},
                    }).then(res=>{  
                        //console.log(item['IDSEQ'],item['LSTSEQ'],res.result.length)
                        if(res.result.length>0 && res.result){
                            let v_idno =res.result[0]['MATIDNO']
                            this.promptWin =true
                            this.prompt ='此附件已被编码：'+v_idno+'引用，如需删除此图片请先删除引用的图片'
                        }else{
                            this.$confirm('你确定要删除此图片吗','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                type:'info',
                            }).then(()=>{
                                this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                                this.imgData.splice(index, 1);    
                            }).catch(()=>{})
                        }
                    })
                }else{
                    this.$confirm('你确定要删除此图片吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                        this.imgData.splice(index, 1);    
                    }).catch(()=>{})
                }
            },
            //上传显示进度
            handleProgress(event,file,fileList){
                this.videoFlag = true
                this.videoUploadPercent = Math.floor(event.percent)
            },
            //文件格式验证错误时的钩子
            handleFormatError (file) {
                this.promptWin =true
                this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择pdf或图片格式'
            },
            //文件超出指定文件大小限制的钩子
            handleMaxSize (file) {
                this.promptWin =true
                this.prompt=file.name + ' 文件太大, 不能超出20M' 
            },
            // 文件上传成功时的钩子
            successImgFile(res,file){
                this.videoUploadPercent=0 
                this.videoFlag = false
                if (res.code=='200'){
                    this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
                }else if (res.code=='201'){ // 文件哈希值存在的情况下
                    this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }               
            },
            //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
            beforeImgFile (res, file) {        
                this.fileName= getDate('year')+'-WK'     
                this.uploadData = {
                    code: this.fileName ,
                    p_type:'IMG',
                    p_path:'/web/web_images/material/',
                    p_user:this.v_username
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise; 
            },
            //表格行 按回车键 到下一行
            nextLine(key,val,reftab){ 
                if (val =='enter'){
                    if (key =='RMK'){
                        this.chkIndex = this.chkIndex +1
                        let v_count=''
                        if (reftab=='refpos'){
                            v_count =this.dtlData.length
                        }
                        if (this.chkIndex >=v_count) {
                            this.chkIndex =0
                        }
                        this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                        if (reftab=='refpos'){
                            this.$refs['pos'+this.chkIndex+'JOBDESC'][0].focus()  
                        } 
                    }else{
                        if (reftab=='refpos'){
                            let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                            v_col.some((item,index)=>{
                                if (item.key==key){
                                this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                                }
                            })
                        }
                    }
                }else if (val =='down'){
                    this.chkIndex = this.chkIndex +1
                    if (reftab=='refpos'){
                        if (this.chkIndex >=this.dtlData.length) {
                            this.chkIndex =0
                        }
                        this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    } 
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+key][0].focus()  
                    }
                }else if (val =='up'){
                    this.chkIndex = this.chkIndex -1
                    if (this.chkIndex <=0) {
                        this.chkIndex =0
                    }              
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+key][0].focus()  
                        this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    } 
                }                    
            },
            dtlAdd(){
                let v_row ={}
                this.dtlCol.forEach(item=>{
                    v_row[item.key] =''
                })
 
                this.dtlData.push(v_row)
                this.delDtlArr=[]
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                }) 
            },
            //明细编辑、删除
            dtlDel(row,index){
                this.delDtlArr.push(row)
                this.dtlData.splice(index,1 )
            },
            //保存记录
            saveRec(){
                let obj_ ={}, v_title='' ,v_amt=0
                // 明细记录非空校验
                this.dtlData.forEach(item => {
                   this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                       if (!item[it.key]){
                           v_title =it['title']
                           return true
                       }
                   }) 
                }) 
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                }else if (this.dtlData.length ==0){
                    this.promptWin =true
                    this.prompt = '明细记录不能为空'
                }else{
                    if ( this.v_commit){
                        this.v_commit =false
                        let v_obj ={'IDSEQ':this.v_idseq,'USERNO':this.v_username,'DTTM':this.v_dttm, CORPID:this.v_corpid,'TY':'WORK'}
                        this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(v_obj), p_table:'hr_msg',frmid:'101'},
                        }).then( res=>{   
                            if (res.code=='200'){ 
                                let idseq_ =res.idseq
                                //明细保存：批量保存  res.idseq
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.dtlData), p_table:'hr_msgdtl',p_idseq:idseq_,p_action:'S' },
                                })
                                //明细删除
                                if (this.delDtlArr.length>0) {
                                    this.$axios({   
                                        method: 'post',
                                        url:'xuper_auth/batDtlSave2',
                                        data: {p_json:JSON.stringify(this.delDtlArr), p_table:'hr_msgdtl',p_idseq:idseq_,p_action:'D' },
                                    })
                                } 
                                //3、图片保存
                                for(var k=0;k<this.imgData.length;k++){
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                                    })
                                }  
                                //图片删除处理
                                for(let k=0;k<this.delImg.length;k++){
                                    let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                                    }).then(res=>{      
                                        if(res.code !=='200')  {  
                                            this.prompt=res.message
                                            this.promptWin=true
                                        }else{                          
                                            //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                            if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                                this.$axios({
                                                    method: 'post',
                                                    url: '/xuper_oss/ftpDelete',
                                                    data: {p_path:'/volume1'+v_path},
                                                }).then(res=>{ 
                                                    console.log(res.result)
                                                })
                                            }
                                        }        
                                    })        
                                }                               
                                this.initCal()
                                this.dayWin =false
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }
                        })   
                    }
                }
            },
            //返回到 当天
            btnDay(){
                this.changeDate(getDate('day'))
                this.v_mth =getDate('month')
            },
            initCal(){
                this.rmkArr=[]
                getTabColOrData(this.v_url, 'V_hr_msg','userno',this.v_username,'corpid',this.v_corpid,'','',' and ty=\'WORK\'  ').then((res) => {
                    this.rmkArr =res.result          
                })
            },
            nextMth(){
                var starttime= this.$moment(this.v_mth+'-01').startOf('month').subtract('month', -1).format('YYYY-MM-DD') //下个月初
                this.returnDate(starttime)
            },
            prevMth(){
                var starttime= this.$moment(this.v_mth+'-01').startOf('month').subtract('month', 1).format('YYYY-MM-DD') //下个月初
                this.returnDate(starttime)
            },
            //月份日志明细
            dayList(){
                this.timeArr=[]
                this.$axios({   
                    method: 'post',
                    url: 'xuper_auth/getBaseData',
                    data: {p_key:'userno', p_value:this.v_username,p_key2:'yrmth', p_value2:this.v_mth,p_cond:' and ty=\'WORK\' AND corpid='+this.v_corpid+' order by tdttm' ,p_table:'V_hr_msg'},
                }).then(res=>{
                    if (res.code=='200'){
                        this.timeArr =res.result                           
                        getTabColOrData(this.v_url,'V_hr_msgdtl','corpid',this.v_corpid,'userno',this.v_username,'YRMTH',this.v_mth,' order by lstseq').then((res) => {               
                            if (res.code=='200'){
                                this.dayArr =res.result   
                                this.$nextTick(()=>{
                                    this.logWin =true 
                                })
                                       
                            }else{
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })   
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }         
                })
            },
            //变更月份
            returnDate(val){
                let dateArr =val.split('-')
                this.$refs.refcal.render(dateArr[0], dateArr[1])
                this.v_mth =this.$moment(dateArr[0]+'-'+dateArr[1]).format('YYYY-MM')
            },
            //改变月份
            changeDate(val){
                let dateArr =val.split('-')
                this.$refs.refcal.render(dateArr[0], dateArr[1])
                this.selDate=[getDate()]
            },
            dayClick(date){
                this.v_mth =this.$moment(date.year+'-'+date.month).format('YYYY-MM')
            },
            //查询附件数据
            qryImgData(idseq){
                getTabColOrData(this.v_url, 'V_mat_img','idseq',idseq,'','').then((res) => {
                    this.imgData=[]
                    if (res){
                        this.imgData =res.result
                    }
                })
            },
            // 日期点击
            editRec(date){
                this.v_dttm= date.year+'-'+date.month+'-'+date.day
                this.v_week =getWeek(this.v_dttm)
                this.dayWin =true
                this.v_mth =this.$moment(date.year+'-'+date.month).format('YYYY-MM')
                this.imgData =[]
                this.dtlData=[]
                this.mainRow ={}
                this.v_idseq=''
                this.v_commit =true
                this.delImg=[]
                getTabColOrData( this.v_url,'V_hr_msg','userno',this.v_username,'dttm',this.v_dttm,'TY','WORK','').then((res) => {
                    if( res.result.length>0){
                        this.v_idseq =res.result[0]['IDSEQ']
                        this.mainRow =JSON.parse(JSON.stringify(res.result[0]))
                        // 明细
                        getTabColOrData(this.v_url, 'V_hr_msgdtl','idseq',this.v_idseq,'','','','',' order by lstseq').then((res) => {               
                            this.dtlData =res.result  
                            this.$nextTick(()=>{
                                this.$refs['refdtl'].doLayout()
                            }) 
                        })
                        this.qryImgData(this.v_idseq)
                    }                      
                })
 
            },
            //获取表列字段
            getTabField(){
                let vm =this
                getTabColOrData(this.v_url, 'v_sys_form_fld','idseq','101','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.mainCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            dotnum:res.result[k].DOTNUM,
                            sortable:res.result[k].SORTABLE,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
 
                getTabColOrData(this.v_url, 'v_sys_form_fld','idseq','101','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.dtlCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            dotnum:res.result[k].DOTNUM,
                            sortable:res.result[k].SORTABLE,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
                getTabColOrData(this.v_url, 'v_sys_form_fld','idseq','407458','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.wkCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            sortable:res.result[k].SORTABLE,
                        })
                    }
                })
            }
        },
  }
</script>
 
<style scoped lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .css_obj{
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 99;
        font-size: 12px;
        display:flex;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        min-width:200px;
    }
    .app-container {
        height:calc(100vh -100px);/*页面高度减120px*/
        display:flex;
        flex-direction:column;
        overflow-y:auto;
    }
    ::v-deep .calendar-pro__body {
        flex:1;
        height: 100%;
    }
    ::v-deep .calendar {
        height: 100%;
        display:flex;
        flex-direction:column;
    }
    ::v-deep .calendar-pro__body table {
        border-collapse: collapse;
        height: 100%;
    }
</style>
 